import type { NextPage } from 'next'
import { News } from '@/client/modules/News'
import { NewsProps } from '@/client/modules/News/types'
import { getCMSContent } from '@/client/utils'

const NewsPage: NextPage<NewsProps> = (data) => <News {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'NEWS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default NewsPage
